import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import DatasetDictionaryFieldTable from '../../fields/containers/DatasetDictionaryFieldTable';
import DictionaryDescription from './DictionaryDescription';
import DatasetDictionaryHeader from './DatasetDictionaryHeader';
import DictionaryUploadMessage from '../components/DictionaryUploadMessage';

const DatasetDictionaryFull = ({
  category,
  code,
  uploadMessages,
  uploadMessagesError,
}) => (
  <div className="aridhia-dataset-dictionary relative">
    <DatasetDictionaryHeader category={category} code={code} />
    <div className="flex items-center justify-between w-100">
      <DictionaryDescription category={category} code={code} />
      {uploadMessages && (<DictionaryUploadMessage messages={uploadMessages} error={uploadMessagesError} />)}
    </div>
    <DatasetDictionaryFieldTable category={category} code={code} />
  </div>
);

const mapStateToProps = ({
  datasets: {
    datasets,
  },
}, { category, code }) => {
  const dataset = findResult(datasets, category, code) || {
    dictionaries: [],
    dictionaryUploadMessages: null,
    dictionaryUploadMessagesError: null,
  };

  return (
    {
      dictionaries: dataset.dictionaries,
      uploadMessages: dataset.dictionaryUploadMessages,
      uploadMessagesError: dataset.dictionaryUploadMessagesError,
    }
  );
};

export default connect(mapStateToProps)(DatasetDictionaryFull);
